import { createSlice } from "@reduxjs/toolkit";

import { fetchTotalValueByStage } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load total value by stage";

const totalValueByStageSlice = createSlice({
  name: "totalValueByStage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalValueByStage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTotalValueByStage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchTotalValueByStage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default totalValueByStageSlice.reducer;
